import React from 'react';
import { ContentWrapper, Container, BlockHeader, BlockFooter } from './styled';

const LayoutTopPage = ({ children }) => {
  return (
    <ContentWrapper>
      <Container>
        <BlockHeader />
        {children}
        <BlockFooter />
      </Container>
    </ContentWrapper>
  );
};

export default LayoutTopPage;
